import * as React from "react";
import { useSelector } from "react-redux";

import { Card, Grid, Menu, Tab } from "semantic-ui-react";

import { Detail } from "@neworbit/simpleui-detail";

import { routeIdSelector } from "../selectors";

import { ConsultationSectionOptions, CustomMedicalTypeDetailModel, QuestionnaireSectionOptions } from "../models";
import { CustomMedicalTypeApi } from "../customMedicalTypesApi";

import { Link } from "redux-little-router";

export const Details: React.FunctionComponent = () => {
    const customMedicalTypeId = useSelector(routeIdSelector);
    const [customMedicalType, setCustomMedicalType] = React.useState<CustomMedicalTypeDetailModel | undefined>(undefined);

    React.useEffect(() => {
        const getCustomMedicalType = async () => {
            const customMedicalTypeData = await CustomMedicalTypeApi.get(customMedicalTypeId);
            setCustomMedicalType(customMedicalTypeData);
        };

        if (customMedicalType === undefined)
        {
            getCustomMedicalType();
        }
    }, [customMedicalType, customMedicalTypeId]);

    if (!customMedicalType)
    {
        return null;
    }

    return (
        <>
            <Grid container className="nomargintop">
                <Grid.Row>
                    <Grid.Column>
                        <h1>{customMedicalType.name}</h1>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={3} as={Grid} padded>
                        <Grid.Column vertical as={Menu}>
                            <Menu.Item name="CustomMedicals" as={Link} href="/customMedicalTypes">
                                All Medicals
                            </Menu.Item>
                        </Grid.Column>
                    </Grid.Column>

                    <Grid.Column width={13}>
                        <Card fluid>
                            <Tab.Pane>
                                <Grid>
                                    <Detail label="Name" value={customMedicalType.name} labelWidth={5} valueWidth={11} />
                                    <Detail
                                        label="Questionnaire Sections"
                                        value={customMedicalType.questionnaireSectionIds
                                            .map(qid => QuestionnaireSectionOptions.find(q => q.value === qid)?.text).join(", ")}
                                        labelWidth={5}
                                        valueWidth={11}
                                    />
                                    <Detail
                                        label="Consultation Sections"
                                        value={customMedicalType.consultationSectionIds
                                            .map(qid => ConsultationSectionOptions.find(q => q.value === qid)?.text).join(", ")}
                                        labelWidth={5}
                                        valueWidth={11}
                                    />
                                </Grid>
                            </Tab.Pane>
                        </Card>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </>
    );
};
